import { OptionItem } from 'tno-core';

export const FileTypes = [new OptionItem('XML', 'xml'), new OptionItem('FMS', 'fms')];
